import axios from "./AxiosInstance"

const GetPreselctedPatientProgram = ({ patientId }) => axios.get(`api/programSelected/users?userId=${patientId}`)

const ProgramService = {
    GetPreselctedPatientProgram
}

export default ProgramService
